export const ADMIN_UIDS = ["lXK7NXhBv4NpeJiNMPLp2cXNHou1"];

export function isAdminUser(authUser, userDocData) {
  if (!authUser) return false;

  if (ADMIN_UIDS.includes(authUser.uid)) return true;

  // Optional future-proofing if your `users/{uid}` doc starts carrying roles.
  if (userDocData?.isAdmin === true) return true;
  if (userDocData?.role === "admin") return true;
  if (Array.isArray(userDocData?.roles) && userDocData.roles.includes("admin")) return true;

  return false;
}

